<template>
  <div v-qa="'main_office_contact'">
    <contacts-section>
      <template #title>
        <h2 class="sf-sb">{{ title }}</h2>
      </template>

      <contacts-group>
        <template #logo><Headset/></template>
        <ul class="list">
          <li v-for="(contact, index) in contacts" :key="index" class="item">
            <component :is="contact.icon" class="item__icon"/>
            <sf-contact-link class="item__link" :type="contact.type" :name="contact.name"/>
          </li>
        </ul>
      </contacts-group>

      <template v-for="group in groups">
        <contacts-group :key="group.key" class="group">
          <template v-slot:logo><component :is="group.logo"/></template>
          <h3 class="group__title">{{ $t(`offices-page.${group.key}-title`) }}</h3>
          <p class="group__text">{{ $t(`offices-page.${group.key}`) }}</p>
          <span v-if="group.isMap" class="toggle-btn" @click="isShowMap = !isShowMap">
            {{ $t('offices-page.open-map-btn') }}
          </span>
        </contacts-group>
      </template>
    </contacts-section>

    <contacts-map v-model="isShowMap" img="offline-office-1"/>
  </div>
</template>

<script>
import ContactsGroup from '~/components/contacts/contacts-group.vue';
import ContactsMap from '~/components/contacts/contacts-map.vue';
import ContactsSection from '~/components/contacts/contacts-section.vue';
import Clock from '~/static/img/icons/clock-time.svg';
import Mail from '~/static/img/icons/email.svg';
import Location from '~/static/img/icons/location.svg';
import Phone from '~/static/img/icons/phone-in-talk.svg';
import Headset from '~/static/img/icons/headset.svg';

export default {
  name: 'MainContact',
  components: { ContactsMap, Headset, ContactsSection, ContactsGroup },

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isShowMap: false,
    };
  },

  computed: {
    contacts() {
      return [{ icon: Phone, type: 'tel', name: 'cc' }, { icon: Mail, type: 'email', name: 'cc' }];
    },

    groups() {
      return [
        { logo: Clock, key: 'working-hours-main' },
        { logo: Location, key: 'location-main', isMap: true },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.list {
  list-style: none;
  padding: 0.3rem 0 0 0;
  margin: 0;
}

.item {
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: map-get($margins, small);
  }

  &__icon {
    @include square(2rem);
    flex-shrink: 0;
    margin-right: 1rem;
    fill: color(secondary);
  }

  &__link {
    font-size: 1.2rem;
    font-weight: 600;

    &:hover {
      transition: 0.3s color ease;
      color: map-get($colors, secondary);
    }
  }
}

.group {
  &__title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: map-get($margins, small);
  }
  &__text {
    font-size: 18px;
    font-weight: 400;
  }
}

.toggle-btn {
  text-transform: uppercase;
  text-decoration: underline;
  cursor: pointer;
  color: color(secondary);
  font-weight: 700;
}
</style>
